import React from "react";
import TermsModal from "@/components/modals/TermsModal";

const Modalcondition = ({ handleClose, show }) => {
  return (
    <TermsModal
      show={show}
      onClose={handleClose}
      termsId="general-terms"
    />
  );
};

export default Modalcondition;